import React, { useMemo } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Link } from "react-router-dom";

import { Grid } from "affinityUI/elements/grid";
import { Heading } from "affinityUI/structures/heading";
import { Layout } from "affinityUI/structures/layout";
import { useGetHospitalConfigQuery, useGetPatientsQuery } from "gql";
import { Restricted } from "lib/auth";
import { getNormalRanges } from "lib/helpers";

import { ConfirmatoryTestInfoTag } from "../../../app/components/confirmatoryTestInfoTag";
import { PatientSearch } from "../../../app/components/patientSearch";
import { PatientsView } from "../../../views/patientDetails/patients";

export const PatientsPage: React.FC = () => {
  const { showBoundary: onError } = useErrorBoundary();
  const { loading, data } = useGetPatientsQuery({
    errorPolicy: "all",
    onError,
  });

  const { data: hospitalConfigData, loading: loadingHospitalConfig } = useGetHospitalConfigQuery();
  const hospitalConfig = hospitalConfigData?.hospitalConfig;
  const neutrophilThreshold = hospitalConfig?.neutrophilThreshold;
  const normalRanges = getNormalRanges(hospitalConfig);

  const checkBelowThreshold = useMemo(
    () => data?.patients?.some((patient) => patient.latestResult?.belowNeutrophilThreshold),
    [data?.patients]
  );
  const actions = (
    <Restricted permits={["add_patient"]}>
      <Link to="add">Add patient</Link>
    </Restricted>
  );

  return (
    <Layout loading={loading || loadingHospitalConfig} title="Patients" actions={<PatientSearch />}>
      <Grid>
        <Heading>
          <Heading.Meta>
            {neutrophilThreshold && checkBelowThreshold ? (
              <ConfirmatoryTestInfoTag neutrophilThreshold={neutrophilThreshold} />
            ) : null}
          </Heading.Meta>
          <Heading.Actions>{actions}</Heading.Actions>
        </Heading>
        {!loading && Boolean(data?.patients) && (
          <PatientsView
            neutrophilThreshold={neutrophilThreshold}
            normalRanges={normalRanges}
            patients={data?.patients}
          />
        )}
      </Grid>
    </Layout>
  );
};
